import * as Yup from 'yup';
import { idStore } from '@pharmaplan/common/helpers/ServiceHandler';
import strings from '../../../../../localization';
import {
  nameRegex,
  onlyNumbersRegex,
  postalCodeRegExp,
} from '../../../../../helpers/Constants';
import { bankAccountValidations, incorporatedProfessionalValidator, numberValidation } from '../../../../../helpers/commonValidators';

const selfValidation = {
  ...bankAccountValidations,
  ...incorporatedProfessionalValidator(),
};
const PharmacistEditProfileValidator = () =>
  Yup.object().shape({
    firstName: Yup.string()
      .required(strings.requiredField)
      .matches(nameRegex, strings.pleaseEnterValidName),
    lastName: Yup.string()
      .required(strings.requiredField)
      .matches(nameRegex, strings.pleaseEnterValidName),
    preferdLanguage: Yup.string().required(strings.requiredField),
    licenseNumber: Yup.string()
      .matches(
        onlyNumbersRegex,
        strings.formatString(
          strings.numberValidation,
          strings.licenseNo,
        ) as string,
      )
      .required(strings.requiredField),
    [idStore.capacityId]: Yup.string().required(strings.requiredField),
    graduationYear: Yup.string().required(strings.requiredField),
    otherLanguages: Yup.string().nullable(),
    province: Yup.string().required(strings.requiredField),
    address: Yup.string().required(strings.requiredField),
    city: Yup.string().required(strings.requiredField),
    prefferedDistanceRange: numberValidation.nullable(),
    postalCode: Yup.string()
      .required(strings.requiredField)
      .matches(postalCodeRegExp, strings.postalCodeValidation),
    phone: Yup.string()
      .required(strings.requiredField)
      .min(
        12,
        strings.formatString(
          strings.phoneValidation,
          strings.homePhone,
        ) as string,
      ),
    mobile: Yup.string()
      .required(strings.requiredField)
      .min(
        12,
        strings.formatString(strings.phoneValidation, strings.mobile) as string,
      ),
    ...selfValidation,
  });

export default PharmacistEditProfileValidator;
